export default __webpack_public_path__ + "static/heroSectionBg-4fa860ba71affcc8669e0bde249c838b.png";